import { useCallback } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const useFormatters = () => {
  const { i18n } = useTranslation();

  const formatNumber = useCallback((num) => {
    if (isNaN(num) || num === null) {
      return "";
    }
    if (num === 0 || Math.abs(num) < 0.0001) {
      return "-";
    }
    return new Intl.NumberFormat(i18n.language, {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num);
  }, []);

  const formatPercentage = useCallback((num) => {
    if (isNaN(num) || num === null) {
      return "";
    }
    if (num === 0 || Math.abs(num) < 0.0001) {
      return "-";
    }
    return new Intl.NumberFormat(i18n.language, {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(num);
  }, []);

  const formatMultiple = useCallback((num) => {
    if (isNaN(num) || num === null) {
      return "";
    }
    if (num === 0 || Math.abs(num) < 0.0001) {
      return "-";
    }
    return (
      new Intl.NumberFormat(i18n.language, {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num) + "x"
    );
  }, []);

  const formatDate = useCallback((date) => {
    if (!date) return "";
    return dayjs(date).format("DD/MM/YY");
  }, []);

  return {
    formatNumber,
    formatPercentage,
    formatMultiple,
    formatDate,
  };
};

export default useFormatters;
